import { defineComponent, createElementBlock, openBlock, normalizeStyle, normalizeClass, unref, createElementVNode, Fragment, renderList, createVNode, toDisplayString, createCommentVNode } from 'vue';
import { useBlockPositioning } from './basler-components.es357.js';
import quoteIcon from './basler-components.es360.js';

const _hoisted_1 = { class: "testimonials-block__inner" };
const _hoisted_2 = {
  class: "testimonials-block__icon",
  "aria-hidden": "true"
};
const _hoisted_3 = { class: "testimonials-block__text" };
const _hoisted_4 = { class: "testimonials-block__person" };
const _hoisted_5 = {
  key: 0,
  class: "testimonials-block__person-image"
};
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = { class: "testimonials-block__person-text" };
const _hoisted_8 = { class: "testimonials-block__person-name" };
const _hoisted_9 = { class: "testimonials-block__person-description" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TestimonialsBlock",
  props: {
    quotes: { default: () => [] },
    cols: { default: 12 },
    colsCentered: { type: Boolean, default: true },
    contentCentered: { type: Boolean, default: false },
    isIconIndented: { type: Boolean, default: true }
  },
  setup(__props) {
    const props = __props;
    const { positioningClassNames } = useBlockPositioning(
      "testimonials-block",
      props.cols,
      props.colsCentered,
      props.contentCentered
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          "testimonials-block",
          unref(positioningClassNames),
          `testimonials-block--items-${props.quotes.length}`,
          `testimonials-block--${props.quotes.length % 2 === 0 ? "items-even" : "items-odd"}`
        ]),
        style: normalizeStyle(`--cols: ${props.cols}`)
      }, [
        createElementVNode("div", _hoisted_1, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(props.quotes, (quote) => {
            return openBlock(), createElementBlock("figure", {
              class: normalizeClass(["testimonials-block__item", { "testimonials-block__item--icon-indent": _ctx.isIconIndented }]),
              key: quote.text
            }, [
              createElementVNode("div", _hoisted_2, [
                createVNode(unref(quoteIcon))
              ]),
              createElementVNode("blockquote", _hoisted_3, toDisplayString(quote.text), 1),
              createElementVNode("figcaption", _hoisted_4, [
                quote.image != null && quote.image !== "" ? (openBlock(), createElementBlock("div", _hoisted_5, [
                  createElementVNode("img", {
                    src: quote.image,
                    alt: quote.name
                  }, null, 8, _hoisted_6)
                ])) : createCommentVNode("", true),
                createElementVNode("div", _hoisted_7, [
                  createElementVNode("div", _hoisted_8, toDisplayString(quote.name), 1),
                  createElementVNode("div", _hoisted_9, toDisplayString(quote.description), 1)
                ])
              ])
            ], 2);
          }), 128))
        ])
      ], 6);
    };
  }
});

export { _sfc_main as default };
